<template>
  <div id="ProductDetails">
    <IndexBottom></IndexBottom>
    <div class="top">
      <div class="topList">
        <h3 @click="boxshow = !boxshow">
          <i class="fa fa-bars" aria-hidden="true"></i>
          <span>商品分类</span>
          <div class="topList-list" v-show="boxshow">
            <ul>
              <li v-for="(item, index) in categoryList" :key="index" @click="goProductDetails(item.id, item.atOname)">
                <span>{{ item.atOname }}</span>
                <i class="el-icon-arrow-right" aria-hidden="true"></i>
              </li>
            </ul>
          </div>
        </h3>
        <ul class="nav">
          <li v-for="(item, index) in categoryList5" :key="index" @click="goProductDetails(item.id, item.atOname)">
            {{ item.atOname }}
          </li>
        </ul>
      </div>
    </div>
    <div class="main">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="Breadcrumb">
        <el-breadcrumb-item :to="{ path: '/ShopIndex' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>商品详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="top-box">
        <div class="top-box-l">
          <div class="top-box-l1">
            <div class="txt1">评价：</div>
            <el-rate :colors="['#F64420', '#F64420', '#F64420']" disabled v-model="starNum"></el-rate>
          </div>
          <div class="top-box-l2">累计评论：<span>{{ AppPlglList.total }}</span></div>
        </div>
        <div class="top-box-r">
          <div class="top-box-btn1" @click="goCart">
            <img class="btn1-img" src="@/assets/img/Slice7@2x.png" alt="">
            <div class="btn1-txt">购物车</div>
          </div>
          <!-- <div class="top-box-btn1" @click="shareF()">
              <img class="btn1-img" src="@/assets/img/Slice2@2x.png" alt="">
              <div class="btn1-txt">分享</div>
          </div>
          <div class="top-box-btn1">
              <img class="btn1-img" src="@/assets/img/Slice8@2x.png" alt="">
              <div class="btn1-txt">联系客服</div>
          </div> -->
        </div>
      </div>
      <div class="main-top">
        <div class="main-top-l">
          <div class="main-top-imgT">
            <img :src="$store.state.imgUrl + bigImg" alt v-if="!VideoFlag" />
            <video :src="$store.state.imgUrl + bigImg" controls :poster="allData.atCoverUrl"
              style="width:100%;height:100%" v-if="VideoFlag"></video>
          </div>
          <div class="main-top-imgB detailSwiper" style="position:relative">
            <swiper :options="swiperOption">
              <swiper-slide v-if="allData.atVideoUrl">
                <div class="min-img" @click="showImg(allData.atVideoUrl, true)">
                  <img :class="isTrue ? 'red-border-j' : ''" :src="$store.state.imgUrl + allData.atCoverUrl" />
                </div>
              </swiper-slide>
              <swiper-slide v-for="(item, index) in atPhotoUrlList" :key="index">
                <div class="min-img" @click="showImg(item.url, false)">
                  <img :class="item.checked ? 'red-border-j' : ''" :src="$store.state.imgUrl + item.url" />
                </div>
              </swiper-slide>
              <!-- Optional controls以下按需使用 -->
            </swiper>
            <!-- <div class="swiper-button-prev swiper-button-black" slot="button-prev"></div> -->
            <!--上一项-->
            <!-- <div class="swiper-button-next swiper-button-black" slot="button-next"></div> -->
            <!--下一项-->
          </div>
        </div>
        <div class="main-top-r">
          <h3>{{ allData.atSpmc }}</h3>
          <p class="pinyin" v-if="allData.optYpfl == 1">
            {{ allData.pinyinName }}
          </p>
          <div class="Collection">
            <div class="Collection-l">
              <!-- let priceInfo = {
        showPrice: list[index].salePrice, // 默认显示原价
        originalPrice: list[index].salePrice,
        type: '原价'
    }; -->
              <p class="p1" v-if="priceInfo.type != '原价'">
                <span class="p-tit1 p-tit">{{ priceInfo.type }}</span>
                <span class="p-money">￥{{ priceInfo.showPrice }}</span>
              </p>
              <p class="p1">
                <span class="p-tit1 p-tit">价格</span>
                <span class="p-money" v-if="specSelected2.length" :style="{
                  'text-decoration':
                    priceInfo.type == '原价' ? 'none' : 'line-through'
                }">￥{{ priceInfo.originalPrice }}</span>
              </p>

              <p class="p2" v-if="allData.optYhlx == 1">
                <span class="p-tit">活动</span>
                <span class="p-tit2">{{ allData.zkbl }}折 到&nbsp;{{
                  getdate(parseInt(this.allData.atJssj) * 1000)
                }}&nbsp;结束</span>
              </p>
              <p class="p2" v-if="allData.optYhlx == 2">
                <span class="p-tit">团购</span>
                <span class="p-tit2">商品{{ allData.zkbl }}折 到{{
                  getdate(parseInt(this.allData.atJssj) * 1000)
                }}结束</span>
              </p>
              <p class="p2" v-if="allData.optYhlx == 3">
                <span class="p-tit">活动</span>
                <span class="p-tit2">暂无活动</span>
              </p>
            </div>
            <div class="Collection-r" @click="Collection()">
              <i class="el-icon-star-off" aria-hidden="true" v-show="shou === false"></i>
              <i class="el-icon-star-on" aria-hidden="true" v-show="shou === true"></i>
              <span>收藏</span>
            </div>
          </div>
          <div class="addressBox">
            <p class="tits tits2">
              <span>配&nbsp;&nbsp;&nbsp;&nbsp;送：</span>
            </p>
            <p class="addressList" @click="centerDialogVisible = true"
              v-if="address && address.ssqName && AddressList.length">
              {{ address.ssqName + ',' + address.atShdz }}
            </p>
            <p class="addressList" @click="goAddAddress()" v-if="!AddressList.length">
              暂无地址
            </p>
          </div>
          <el-dialog class="dialogs" title="选择配送地址" :visible.sync="centerDialogVisible" width="630px" center>
            <div class="addressLists">
              <div class="addressLi" v-for="(item, index) in AddressList" :key="index"
                :class="item.active ? 'active2' : ''" @click="addressChange(item, index)">
                <div class="tip" v-show="item.optSfmr == 1">默认</div>
                <div class="li-top">
                  <div class="top-l">{{ item.atName }}</div>
                  <div class="top-r">{{ item.atLxfs }}</div>
                </div>
                <div class="li-btm">{{ item.ssqName + "," + item.atShdz }}</div>
              </div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button class="btn1" @click="centerDialogVisible = false">取 消</el-button>
              <el-button class="btn2" type="primary" @click="addressSave()">确 定</el-button>
            </span>
          </el-dialog>
          <div class="pfBox">
            <p>
              <span>批发价：</span>
              <span v-if="specSelected2.length && wholesaleFlag">￥{{ specSelected2[0].wholesalePrice }}</span>
            </p>
            <p v-if="wholesaleFlag" class="p2">
              <span>起批量：</span>
              <span>{{ wholesaleCount }}</span>
              <span>{{ defaultUnit }}</span>
            </p>
            <p v-if="!wholesaleFlag" class="p3">
              该包装不支持批发
            </p>
          </div>
          <div class="pfBox" v-if="userInfo.isMerchant == 1">
            <p>
              <span>批发商批发价：</span>
              <span>￥{{ specSelected2.length ? specSelected2[0].merchantPrice : 0 }}</span>
            </p>
            <p class="p2">
              <span>起批量：</span>
              <span>{{ specSelected2.length ? specSelected2[0].merchantCount : 0 }}</span>
              <span>{{ defaultUnit }}</span>
            </p>
          </div>
          <div class="ggBox">
            <div class="tits">规&nbsp;&nbsp;&nbsp;&nbsp;格：</div>
            <ul>
              <li v-for="(childItem, childIndex) in spggList" :key="childIndex"
                :class="{ selecteds: childItem.selected }" @click="selectSpec(childIndex, childItem)">
                {{ childItem.standard }}
              </li>
            </ul>
          </div>
          <div class="bzBox">
            <div class="tits">包&nbsp;&nbsp;&nbsp;&nbsp;装：</div>
            <ul>
              <li v-for="(childItem2, childIndex2) in spggDetailList" :key="childIndex2"
                :class="{ selecteds: childItem2.selected }" @click="selectSpec2(childIndex2, childItem2)">
                {{ childItem2.unit2 }}
              </li>
            </ul>
          </div>
          <p class="nums">
            <span class="tits">数&nbsp;&nbsp;&nbsp;&nbsp;量：</span>
            <el-input-number v-model="num" :step="1" step-strictly :min="1" class="btns"
              @change="numChange"></el-input-number>
            <span class="paddingR">&nbsp;&nbsp;</span>
            <span v-if="stockQty2">库存量：</span>
            <span v-if="stockQty2">{{ stockQty2 }}</span>
            <span v-if="stockQty2">{{ defaultUnit }}</span>
          </p>
          <div class="main-top-btn">
            <p class="btns btnL" v-if="allData.optYhlx == 1" @click="OrderNow2(allData.spYhxx)">
              立即购买
            </p>
            <p class="btns btnL" v-if="allData.optYhlx == 3" @click="OrderNow()">
              立即购买
            </p>
            <p class="btns btnL" v-if="allData.optYhlx == 2" @click="signUp(allData.groupId, allData.spYhxx)">
              立即参团
            </p>
            <p class="btns btnR" @click="addCar()">加入购物车</p>

            <p class="fen" @click="shareF()">
              <i class="fa fa-share-alt" aria-hidden="true"></i>
              <span>分享</span>
            </p>
          </div>
          <div class="sharef fl" v-show="isShare">
            <share :config="config1" style="display:inline-block" v-if="isShare"></share>
          </div>
        </div>
      </div>
      <p class="dataNum">
        <span>月销量：</span>
        <span>{{ allData.monthSaleCount ? allData.monthSaleCount : 0 }}</span>
        <!-- <span class="paddingR">{{ allData.atBzgg }}</span> -->
        <span class="shou" @click="goDiv('商品评论')">
          <span>累计评价：</span>
          <span class="tiao">{{ AppPlglList.total }}</span>
          <span>条</span>
        </span>
      </p>
      <div class="navs">
        <p v-for="(item, index) in navs" :key="index" :class="{ active: item.style }" @click="goDiv(item.name)">
          {{ item.name }}
        </p>
      </div>
      <div class="main-table">
        <table>
          <tbody>
            <tr>
              <td class="tableTit">商品名称：</td>
              <td class="tableTit2">
                <p>{{ allData.atSpmc }}</p>
              </td>
              <td class="tableTit">拼音名称：</td>
              <td class="tableTit2">
                <p>{{ allData.pinyinName }}</p>
              </td>
            </tr>
            <tr>
              <td class="tableTit">商品别名：</td>
              <td class="tableTit2">
                <p :title="allData.drugAlias">{{ allData.drugAlias }}</p>
              </td>
              <td class="tableTit">药性：</td>
              <td class="tableTit2">
                <p>{{ allData.medicine }}</p>
              </td>
            </tr>
            <tr>
              <td class="tableTit">药味：</td>
              <td class="tableTit2">
                <p>{{ allData.pill }}</p>
              </td>
              <td class="tableTit">药用部位：</td>
              <td class="tableTit2">
                <p>{{ allData.medicinalPart }}</p>
              </td>
            </tr>
            <tr>
              <td class="tableTit">有效期：</td>
              <td class="tableTit2">
                <p>{{ allData.atYouxiaoqi }}</p>
              </td>
              <td class="tableTit">归经：</td>
              <td class="tableTit2">
                <p>{{ allData.channelTropism }}</p>
              </td>
            </tr>
            <tr>
              <td class="tableTit">商品产地：</td>
              <td class="tableTit3" colspan="3">
                <p>{{ allData.atSpcd }}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="explain" id="explain2">
        <h3>药品主治</h3>
        <p>{{ allData.drugIndications }}</p>
      </div>
      <div class="explain">
        <h3>药品用法用量</h3>
        <p>{{ allData.drugUsageAndDosage }}</p>
      </div>
      <div class="explain">
        <h3>与之相反的药物</h3>
        <p>{{ allData.reverseDrugs }}</p>
      </div>
      <div class="explain">
        <h3>产地分布描述</h3>
        <p>{{ allData.originDistributionDescribe }}</p>
      </div>
      <div class="explain">
        <h3>植物形态特征</h3>
        <p>{{ allData.plantShapeDescribe }}</p>
      </div>
      <div>
        <div class="explainImg" v-for="(item2, index2) in atDetailUrlList" :key="index2">
          <img :src="$store.state.imgUrl + item2" alt />
        </div>
      </div>

      <div class="navs" id="navs2">
        <p class="active">商品评论</p>
        <p class="navR">
          <span>{{ AppPlglList.total }}</span>
          <span>条</span>
        </p>
      </div>
      <div class="Proportion">
        <div class="ProportionL">
          <p class="ProportionL1">
            {{ PlglCountList.hpPercent ? PlglCountList.hpPercent : 0 }}%
          </p>
          <p class="ProportionL2">好评率</p>
        </div>
        <div class="ProportionC">
          <div class="ProportionC1">
            <span>好评</span>
            <el-progress :stroke-width="10" :percentage="PlglCountList.hpPercent" class="tiao"></el-progress>
          </div>
          <div class="ProportionC1">
            <span>中评</span>
            <el-progress :stroke-width="10" :percentage="PlglCountList.zpPercent" class="tiao"></el-progress>
          </div>
          <div class="ProportionC1">
            <span>差评</span>
            <el-progress :stroke-width="10" :percentage="PlglCountList.cpPercent" class="tiao"></el-progress>
          </div>
        </div>
        <div class="ProportionR" v-show="false">
          <p class="ProportionR1">发表评论</p>
          <p class="ProportionR2">购买过该商品的用户可以进行评价</p>
        </div>
      </div>
      <div class="chenges">
        <div class="radioList">
          <el-radio v-model="radio" label @change="ping()">全部</el-radio>
          <el-radio v-model="radio" label="hp" @change="ping()">好评</el-radio>
          <el-radio v-model="radio" label="zp" @change="ping()">中评</el-radio>
          <el-radio v-model="radio" label="cp" @change="ping()">差评</el-radio>
        </div>
      </div>

      <!-- 评价  -->
      <div class="evaluateWrap">
        <div class="evaluate" v-for="(item, index) in AppPlglList.list" :key="index">
          <div class="imgs">
            <img :src="$store.state.imgUrl + item.headImg" alt />
          </div>
          <div class="evaluateC">
            <div class="evaluateC1">
              <span v-if="item.atNmpl == 0">******</span>
              <span v-else>{{ item.userName }}</span>
              <span class="data">{{ item.createDate }}</span>
              <el-rate disabled v-model="item.atPjxj" score-template="{item.atPjxj}" class="star"></el-rate>
            </div>
            <div class="evaluateC2">
              <p>{{ item.atPjnr }}</p>
              <!-- <ul v-if="false">
                <li v-for="(item,index) in list" :key="index">
                  <img src="@/assets/img/4.png" alt />
                </li>
                            </ul>-->
            </div>
            <div class="evaluateC3" v-for="(item1, index1) in item.plhfList" :key="index1" v-show="item.plhfList">
              <p>
                <span>{{ item1.userName }} :</span>
                <span>{{ item1.atHfnr }}</span>
              </p>
            </div>
          </div>
          <div class="functions">
            <p @click="more(item.id, index)">
              <span>更多</span>
              <i class="el-icon-caret-bottom"></i>
            </p>
            <p @click="pingChild(item.id, '0', item.userName, index)">
              <span>{{ item.plhfCount }}</span>
              <i class="el-icon-chat-dot-round"></i>
              <span>评论</span>
            </p>
          </div>
          <!-- {{item}} -->
          <div class="evaluateWrap2" v-if="item.xianshi">
            <!-- {{item.childs}} -->
            <div class="evaluate" v-for="(item2, index2) in item.childs" :key="index2">
              <div class="imgs">
                <img :src="$store.state.imgUrl + item2.headImg" alt />
              </div>
              <div class="evaluateC">
                <div class="evaluateC1">
                  <span>{{ item2.userName }}</span>
                  <span v-if="item2.hfrName" style="padding:0 5px;font-weight:600">回复</span>
                  <span v-if="item2.hfrName">{{ item2.hfrName }}</span>
                  <span class="data">{{ item2.stringCreateDate }}</span>
                </div>
                <div class="evaluateC2">
                  <p>{{ item2.atHfnr }}</p>
                </div>
              </div>
              <div class="functions">
                <p @click="
                  pingChild(item2.id, '1', item2.userName, index, item.id)
                  ">
                  <i class="el-icon-chat-dot-round"></i>
                  <span>评论</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="page" v-if="AppPlglList.total > 10">
        <el-pagination background layout="prev, pager, next" :total="AppPlglList.total" @size-change="handleSizeChange"
          @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import IndexBottom from "@/components/ShoppingMall/IndexBottom";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  name: "ProductDetails",
  data() {
    return {
      starNum: 5,
      isTrue: true, //视频轮播默认选中
      userId: "",
      boxshow: false, //分类show
      categoryList: [], //商品分类
      categoryList5: [], //商品分类(推荐的五条)
      shou: null, //判断收藏与否
      navs: [
        { name: "商品参数", style: true },
        { name: "商品详情", style: false },
        { name: "商品评论", style: false }
      ],
      allData: [], //所有数据
      ypsx: [], //内层数据
      atPhotoUrlList: [
        // "http://47.105.180.14/group1/M00/00/08/rB9d-F5XeO-AOBq7AAOdzEWhnOI264.jpg",
        // "http://47.105.180.14/group1/M00/00/08/rB9d-F5XePqAc-DzAAD5hUr5KRE894.jpg",
        // "http://47.105.180.14/group1/M00/00/08/rB9d-F5XehKAYjtiAACd7smqMig177.jpg",
        // "http://47.105.180.14/group1/M00/00/08/rB9d-F5XeO-AOBq7AAOdzEWhnOI264.jpg",
        // "http://47.105.180.14/group1/M00/00/08/rB9d-F5XePqAc-DzAAD5hUr5KRE894.jpg",
        // "http://47.105.180.14/group1/M00/00/08/rB9d-F5XehKAYjtiAACd7smqMig177.jpg"
      ], //商品图片
      bigImg: "", //大图
      atDetailUrlList: [], //商品详情图片
      AppPlglList: [], //评价数据
      pingMore: [], //子评价
      PlglCountList: [], //比例
      num: 1, //添加商品数
      swiperOption: {
        loop: false,
        speed: 800,
        autoplay: false,
        direction: "horizontal",
        slidesPerView: 5,
        // grabCursor: true,
        // observeParents: true,
        observer: true,
        observeParents: true,
        //左右点击
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      radio: "", //评价单选
      value: 0, //星星
      pageNum: 1,
      VideoFlag: false,
      cantuan: false, //是否立即参团
      cantuanId: "", //参团id
      zhekouId: "", //折扣id
      stanceImg: "", //视频封面图
      spggList: [],//规格数组
      specSelected: [], //存储当前选中的规格信息
      specSelected2: [], //存储当前选中的包装信息
      spggList: [], //存储规格信息
      spggDetailList: [], //存储包装信息
      stockQty: 0, //存储当前规格总库存
      stockQty2: 0, //修改后的库存
      defaultUnit: '', //存储当前规格最小单位
      wholesale: 0, //批发数量值用于计算优惠
      wholesaleCount: 0, //起批数量
      salePrice: 0, //存储当前一份价格值
      wholesaleFlag: false, //判断当前规格包装是否可批发
      merchantCount: 0,//批发商批发起批量
      btnFlag: null, //1购物车2立即购买
      centerDialogVisible: false,
      address: {},//选中的地址
      address2: {},//用来暂存选中的地址
      AddressList: [],//地址列表
      priceInfo: {},//展示当前规格数量的优惠及价格
    }
  },
  components: {
    IndexBottom: IndexBottom,
    swiper,
    swiperSlide
  },
  created() {
    if (sessionStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      this.userId = this.userInfo.id;
      this.getAddress();//获取地址
    }
  },
  mounted() {
    this.getType(); //获取分类
    this.getData(); //获取详情信息
    this.getEvaluate(); //评价
    this.getPlglCount(); //比例
  },
  methods: {
    numChange(e) {
      this.num = e;

      this.selectSpec2(this.specSelected2[0].index, this.specSelected2[0])
    },
    goProductDetails(id, name) {
      //分类跳转
      this.$router.push({ path: "/commodity/" + id + "/" + name });
    },
    showImg(img, flag) {
      // debugger
      //判断是否是视频
      for (let i = 0; i < this.atPhotoUrlList.length; i++) {
        this.atPhotoUrlList[i].checked = false;
      }
      if (flag) {
        this.VideoFlag = true;
        this.isTrue = true;
      } else {
        this.VideoFlag = false;
        this.isTrue = false;
        for (let i = 0; i < this.atPhotoUrlList.length; i++) {
          if (img.url == this.atPhotoUrlList[i].url) {
            this.atPhotoUrlList[i].checked = true;
          }
        }
      }
      this.bigImg = img;
    },
    Collection() {
      if (this.userId) {
        //判断是否收藏
        var id = this.$route.params.id;
        var params = {};
        params.id = id;
        params.type = "2"; //商品
        params.userId = this.userId;
        var url = "";
        if (this.shou === true) {
          url = "/common/unCollection";
        } else if (this.shou === false) {
          url = "/common/collection";
        }
        //分类渲染
        this.$http.post(url, params).then(res => {
          if (res.data.code == 200) {
            // console.log(this.shou);
            if (this.shou === false) {
              this.$message({
                type: "success",
                message: "收藏成功"
              });
            } else {
              this.$message({
                type: "success",
                message: "已取消收藏"
              });
            }
            this.shou = !this.shou;
          }
        });
      } else {
        this.$confirm("您还未登录，是否登录", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$router.push({ path: "/login" });
        });
      }
    },
    getType() {
      //分类渲染
      let url = "/spfl/getListBySpgl";
      this.$http.post(url).then(res => {
        if (res.data.code == 200) {
          // console.log(res);
          this.categoryList = res.data.data;
          // console.log(this.categoryList);
          for (var i = 0; i < this.categoryList.length; i++) {
            if (this.categoryList.length < 5) {
              this.categoryList5.push(this.categoryList[i]);
            } else {
              if (i < 6) {
                this.categoryList5.push(this.categoryList[i]);
              }
            }
          }
        }
      });
    },
    getData() {
      var id = this.$route.params.id;
      // var params = new URLSearchParams();
      // params.append('id',id)
      var params = {};
      params.id = id;
      params.userId = this.userId;
      params.updateBy = this.userId;
      params.dzglId = this.address.id ? this.address.id : null;
      let url = "/spgl/spglByDetailV2";
      this.$http.post(url, params).then(res => {
        if (res.data.code == 200) {
          // console.log(res);
          this.allData = res.data.data;
          this.ypsx = this.allData.ypsx;
          let atPhotoUrlList1 = [];
          atPhotoUrlList1 = this.allData.atPhotoUrl.split(","); //商品图片
          this.atPhotoUrlList = [];
          for (let i = 0; i < atPhotoUrlList1.length; i++) {
            this.atPhotoUrlList.push({
              url: atPhotoUrlList1[i],
              checked: false
            });
          }
          this.address = this.allData.dzgl;
          this.spggList = this.allData.spggList;
          this.selectSpec(0, this.spggList[0]); //默认展示第一个规格
          this.selectSpec2(0, this.spggList[0].spggDetailList[0]); //默认展示第一个包装
          if (this.allData.atDetailUrl) {
            this.atDetailUrlList = this.allData.atDetailUrl.split(","); //商品详情图片
          }
          if (this.allData.atVideoUrl) {
            this.VideoFlag = true;
            this.bigImg = this.allData.atVideoUrl;
          } else {
            this.VideoFlag = false;
            this.bigImg = this.atPhotoUrlList[0].url;
          }
          if (res.data.data.isAtSccs == 1 && this.userId) {
            //判断是否收藏
            this.shou = true;
          } else {
            this.shou = false;
          }
        }
      });
    },
    //选择规格
    selectSpec(index, item) {
      let list = this.spggList;
      list.forEach(items => {
        this.$set(items, 'selected', false);
      })
      this.spggDetailList.forEach(items => {
        this.$set(items, 'selected', false);
      })
      this.$set(list[index], 'selected', true);
      item.spggDetailList.forEach(itemss => {
        if (!item.stockQty) {
          itemss.unit2 = itemss.unit + ' (无货)';
        } else {
          itemss.unit2 = itemss.unit + (itemss.unitByDefault ? '(' + itemss.unitByDefault + ')' : '');
        }
      })
      this.spggDetailList = item.spggDetailList;
      this.stockQty = item.stockQty;
      this.stockQty2 = item.stockQty;
      this.defaultUnit = item.defaultUnit;
      //存储已选择
      this.specSelected = [];
      list.forEach(item => {
        if (item.selected === true) {
          item.index = index;
          this.specSelected.push(item);
        }
      })
      this.selectSpec2(0, item.spggDetailList[0]); //拿当前规格下的第一个包装

    },
    //选择包装
    selectSpec2(index, item) {
      let list = this.spggDetailList;
      this.wholesaleCount = list[index].wholesaleCount; //起批数量
      list.forEach(items => {
        this.$set(items, 'selected', false);
      })
      this.$set(list[index], 'selected', true);
      this.wholesaleFlag = list[index].wholesaleCount && list[index].wholesaleCount > 0 ? true : false; //是否可批发

      let stockQty = (this.stockQty / list[index].rate).toFixed(2); //计算当前包装的库存
      this.stockQty2 = Number(stockQty);
      this.defaultUnit = list[index].unit;
      this.specSelected2 = [];
      //计算折扣价
      // 将小数转换为BigInt，先乘以100（假设价格最多到小数点后两位）
      let result = 0;

      if (this.allData.optYhlx == 1 || this.allData.optYhlx == 2) {
        const num = list[index].salePrice;
        const numAsBigInt = BigInt(num * 100);
        const discount = this.allData.zkbl * 10; // 九折即90%
        const resultAsBigInt = (numAsBigInt * BigInt(discount)) / BigInt(100);
        // 转换回浮点数
        result = Number(resultAsBigInt) / 100;
        if (result < 0.01) {
          result = 0.01
        }
      }
      let priceInfo = {
        showPrice: list[index].salePrice, // 默认显示原价
        originalPrice: list[index].salePrice,
        type: '原价'
      };

      // 判断是否为批发商
      if (this.userInfo.isMerchant == 1) {
        // 检查是否有批发商起批量和对应的价格
        if (list[index].merchantCount && list[index].merchantCount > 0) {
          // 判断当前值是否达到批发商起批量
          console.log(list[index].merchantCount, this.num)
          if (this.num >= list[index].merchantCount) {
            priceInfo.showPrice = item.merchantPrice;
            priceInfo.type = '批发商价';
          }
        }
      }

      // 如果还是原价（可能不是批发商或者没达到批发商起批量）
      if (priceInfo.type === '原价') {
        // 检查是否有普通批发起批量和对应的价格
        if (list[index].wholesaleCount && list[index].wholesaleCount > 0) {
          // 判断当前值是否达到普通批发起批量
          if (this.num >= list[index].wholesaleCount) {
            priceInfo.showPrice = item.wholesalePrice;
            priceInfo.type = '批发价';
          }
        }
      }

      // 如果还是原价（可能没达到普通批发起批量）
      if (priceInfo.type === '原价') {
        // 检查是否有优惠价格
        if (this.allData.optYhlx == 1) {
          priceInfo.showPrice = result;
          priceInfo.type = '优惠';
        }
      }
      this.$set(this, 'priceInfo', priceInfo);


      list.forEach(item => {
        if (item.selected === true) {
          item.index = index;
          this.specSelected2.push(item);
        }
      })

    },
    //获取地址列表
    getAddress() {
      let that = this;
      //获取地址
      var params = {};
      params.createBy = this.userId;
      let url = "/dzgl/getList";
      this.$http.post(url, params).then(res => {
        if (res.data.code == 200) {
          let AddressList = res.data.data.list;
          AddressList.forEach((item, index) => {
            if (item.optSfmr == 1) {
              item.active = true;
            } else {
              item.active = false
            }
          })
          that.$set(that, 'AddressList', AddressList);
        }
      });
    },
    goAddAddress() {
      this.$confirm("您还未创建地址，是否去创建", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$router.push({ path: "/myAddress" });
      });
    },
    addressChange(item, index) {
      this.AddressList.forEach(items => {
        this.$set(items, 'active', false);
      })
      this.$set(this.AddressList[index], 'active', true);
      this.address2 = this.AddressList[index];
    },
    addressSave() {
      this.$set(this, "address", this.address2);
      this.getData();//再次获取当前仓库的商品详情信息
      this.centerDialogVisible = false
    },
    getEvaluate() {
      var id = this.$route.params.id;
      var params = {};
      params.userId = this.userId;
      params.spSpgl = id;
      params.type = this.radio; //评价类型
      params.pageNum = this.pageNum;
      params.pageSize = 10;
      let url = "/plgl/getAppPlglList";
      this.$http.post(url, params).then(res => {
        if (res.data.code == 200) {
          // console.log(res, 333);
          this.AppPlglList = res.data.data;
          for (var i = 0; i < this.AppPlglList.list.length; i++) {
            this.AppPlglList.list[i].createDate = this.getTime(
              this.AppPlglList.list[i].createDate
            );
            // this.AppPlglList.list[i].childs = [];//建一个子集
          }
        } else {
          this.$message(res.data.msg);
        }
      });
    },
    getPlglCount() {
      var id = this.$route.params.id;
      // var params = new URLSearchParams();
      //  params.append('spSpgl',id);
      var params = {};
      params.spSpgl = id; //
      let url = "/plgl/getPlglCount";
      this.$http.post(url, params).then(res => {
        if (res.data.code == 200) {
          // console.log(res);
          this.PlglCountList = res.data.data;
        }
      });
    },
    goDiv(name) {
      if (name == "商品评论") {
        document.getElementById("navs2").scrollIntoView({ behavior: "smooth" });
      }
      if (name == "商品详情") {
        document
          .getElementById("explain2")
          .scrollIntoView({ behavior: "smooth" });
      }
    },
    ping() {
      //评价切换
      // console.log(this.radio);
      this.pageNum = 1;
      this.getEvaluate();
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getEvaluate();
      this.goDiv("商品评论");
    },
    signUp(id1, id2) {
      //立即参团 id1=参团id,id2 = 折扣id
      this.cantuanId = id1; //参团id
      this.zhekouId = id2; //参团id
      this.OrderNow();
    },
    OrderNow2(id) {
      //折扣商品 id = 折扣id
      this.zhekouId = id; //参团id
      this.OrderNow();
    },
    OrderNow() {
      if (this.userId) {
        //立即购买
        if (this.num == 0) {
          this.$message.error("请选择商品数量");
        } else {
          if (this.address) {
            if (!this.stockQty2) {
              this.$message.error("当前选择的配送地区没有库存，请更改地址");
              return false
            }
          } else {
            this.goAddAddress();
            return false
          }

          let ddmxList = [];
          let data = {};
          data.userId = this.userId;
          let obj = {};
          obj.spSpgl = this.$route.params.id; //商品id
          obj.atSpsl = this.num; //商品数量
          obj.spSpgg = this.specSelected[0].id; //规格的id
          obj.spSpggDetail = this.specSelected2[0].id; //规格明细的id
          obj.isWholesale = this.num > this.specSelected2[0].wholesaleCount || this.num == this
            .specSelected2[0].wholesaleCount ? 1 : 0; //是否批发 0：否，1：是
          ddmxList.push(obj);
          data.ddmxList = ddmxList;
          data.dzglId = this.address ? this.address.id : null; //地址id
          data.spCkgl = this.allData.ckgl ? this.allData.ckgl.id : null; //仓库id

          // console.log(arr, "params.ddmxList");
          sessionStorage.setItem("ddmxList", JSON.stringify(data)); //存储获取订单所需数据

          this.$router.push({
            path: "/ReceivingAddress",
            query: { type: 0 }
          });
        }
      } else {
        this.$confirm("您还未登录，是否登录", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$router.push({ path: "/login" });
        });
      }
      if (this.userId && !this.stockQty2) {
        this.$message.error("该商品没有库存");
        return false
      }
    },
    addCar() {
      if (this.userId) {
        if (this.num == 0) {
          this.$message.error("请选择商品数量");
        } else {

          var id = this.$route.params.id;
          var params = {};
          params.spSpgl = id; //
          params.userId = this.userId;
          params.atSpsl = this.num;
          params.spSpggDetail = this.specSelected2[0].id;
          let url = "/gwcgl/save";
          this.$http.post(url, params).then(res => {
            if (res.data.code == 200) {
              this.$message({
                message: "加入购物车成功",
                type: "success"
              });
            }
          });
        }
      } else {
        this.$confirm("您还未登录，是否登录", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$router.push({ path: "/login" });
        });
      }
    },
    more(id, index) {
      if (this.AppPlglList.list[index].xianshi) {
        this.AppPlglList.list[index].xianshi = false;
        return false;
      }
      //更多
      let that = this;
      var params = {};
      params.id = id; //
      let url = "/plgl/getAppPlhf";
      that.$http.post(url, params).then(res => {
        if (res.data.code == 200) {
          that.pingMore = res.data.data.plhfList;
          // that.AppPlglList.list[index].childs = res.data.data.plhfList;
          //  that.AppPlglList.list[index].childs.push('111');
          if (res.data.data.plhfList.length) {
            // console.log(123);
            // this.AppPlglList.list[index].childs = this.pingMore;
            that.$set(that.AppPlglList.list[index], "childs", that.pingMore);
            that.$set(that.AppPlglList.list[index], "xianshi", true);
            // that.$set(that.AppPlglList.list[index],'childs',[1111]);
            // that.AppPlglList.list[index] = Object.assign({},that.AppPlglList.list[index],{childs:res.data.data.plhfList})
          }
        }
      });
    },
    pingChild(id, type, Name, index, parentId) {
      if (!this.userId) {
        this.$confirm("您还未登录，是否登录", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$router.push({ path: "/login" });
        });
        return false;
      }
      //评论子评论
      this.$prompt("回复" + Name + ":", "评价", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(({ value }) => {
          var params = {};

          params.atSuperior = type; //子评论传0，评论回复传1
          if (type == 0) {
            params.spPlgl = id;
            params.atParent = id; //atSuperior为0时传评论id，为1时 传被回复id
          } else if (type == 1) {
            params.spPlgl = parentId;
            //  params.atParent = parentId; //atSuperior为0时传评论id，为1时 传被回复id
            params.atParent = id; //atSuperior为0时传评论id，为1时 传被回复id
          }

          params.atHfnr = value; //回复内容
          params.userId = this.userId;
          let url = "/plhf/save";
          this.$http.post(url, params).then(res => {
            if (res.data.code == 200) {
              if (parentId) {
                this.more(parentId, index);
              } else {
                this.more(id, index);
              }

              this.$message({
                type: "success",
                message: "回复" + Name + "成功"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入"
          });
        });

      // console.log(id);
      // var params = {};
      // params.spPlgl = id; //
      // params.atSuperior = type; //子评论传0，评论回复传1
      // params.atParent = id; //atSuperior为0时传评论id，为1时 传被回复id
      // params.userId = this.userId;
      // let url = "/plhf/save";
      // this.$http.post(url, params).then(res => {
      //   if (res.data.code == 200) {
      //     this.AppPlglList;
      //   }
      // });
    },
    goCart() {
      this.$router.push({ path: "/car" });
    }
  }
};
</script>
<style scoped>
.shou {
  margin-left: 10px;
}

#ProductDetails {
  width: 100%;
  background: #fff;
}

#ProductDetails .top {
  width: 100%;
  background: #f0f0f0;
}

.topList {
  border-bottom: 0;
  max-width: 1440px;
  max-width: 80%;
  width: 1024px;
  margin: 0px auto;
}

.Breadcrumb {
  margin: 20px 0;
}

.main {
  max-width: 1440px;
  max-width: 80%;
  width: 1024px;
  margin: 0px auto;
}

.main-top {
  width: 100%;
  height: 490px;
}

.main-top-l {
  float: left;
  height: 100%;
  width: 45%;
}

.main-top-imgT {
  width: 100%;
  height: 380px;
  overflow: hidden;
}

.main-top-imgT img {
  display: block;
  width: 100%;
  min-height: 100%;
  height: auto;
}

.main-top-imgB {
  width: 100%;
  height: 90px;
  margin-top: 20px;
}

.min-img {
  width: 100%;
  height: 70px;
  overflow: hidden;
}

.min-img img {
  display: block;
  width: 90%;
  /* width: 90px; */
  /* min-height: 100%; */
  margin: 0 auto;
  height: 65px;
}

.main-top-r {
  float: right;
  height: 100%;
  width: 52%;
}

.main-top-r h3 {
  font-size: 23px;
  height: 25px;
  line-height: 25px;
  color: #333;
  font-weight: 600;
  margin: 0px 0 5px 0;
}

.main-top-r .pinyin {
  font-size: 16px;
  color: #909090;
}

.Collection {
  width: 100%;
  height: 96px;
  box-sizing: border-box;
  padding: 10px;
  background: #fef6ee;
  margin-top: 15px;
}

.Collection-l {
  float: left;
  width: 79.5%;
  height: 70px;
  border-right: 1px solid #ccc;
}

.Collection-l .p1 {
  width: 50%;
  height: 35px;
  float: left;
  margin-bottom: 10px;
  margin-top: 0;
}

.Collection-l .p2 {
  clear: both;
}

.p-tit {
  font-size: 16px;
  color: #666;
  padding-right: 10px;
}

.p1 .p-tit1 {
  font-size: 16px;
  color: #666;
}

.p-tit2 {
  color: #e9821e;
}

.p-tit3 {
  cursor: pointer;
  margin-left: 10px;
  font-weight: 600;
  color: #f64420;
  border: 1px solid #f64420;
  padding: 5px;
}

.p1 .p-money {
  font-size: 25px;
  color: #f64420;
}

.Collection-r {
  float: right;
  width: 20%;
  height: 30px;
  line-height: 30px;
  margin-top: 20px;
  cursor: pointer;
}

.Collection-r i {
  display: block;
  float: left;
  font-size: 30px;
  color: #f64420;
  margin-left: 15px;
  margin-right: 5px;
}

.Collection-r span {
  display: block;
  float: left;
  font-size: 18px;
  color: #f64420;
  padding-top: 3px;
}

.dataNum {
  height: 25px;
  line-height: 25px;
  color: #777;
  margin-top: 30px;
}

.paddingR {
  padding-right: 30px;
}

.tiao {
  color: #f64420;
  font-size: 18px;
}

.nums {
  color: #777;
  height: 30px;
  line-height: 30px;
  margin-top: 20px;
}

.nums span {
  float: left;
}

.btns {
  float: left;
  width: 120px;
}

.nums .btn {
  float: left;
  width: 50px;
  margin: 0 5px;
  text-align: center;
}

.nums .btn1 {
  font-size: 25px;
  font-weight: 100;
  display: block;
  width: 29px;
  height: 29px;
  line-height: 29px;
  text-align: center;
  background: #f6f6f6;
  border: 1px solid #ddd;
  cursor: pointer;
}

.tits {
  margin-right: 10px;
}

/*地址选择*/
.addressBox {
  width: 100%;
  color: #777;
  height: 30px;
  line-height: 30px;
  margin-top: 10px;
}

.addressBox p {
  float: left;
}

.addressBox .tits2 {
  width: 50px;
}

.addressBox .addressList {
  width: 420px;
  white-space: nowrap;
  /* 确保文本在一行内显示 */
  overflow: hidden;
  /* 隐藏溢出的内容 */
  text-overflow: ellipsis;
  /* 使用省略号表示文本溢出 */
  cursor: pointer;
}

.addressBox .addressList:hover {
  color: #f68f26;
}

/* 批发模块样式*/
.pfBox {
  width: 100%;
  color: #777;
  height: 30px;
  line-height: 30px;
  margin-top: 10px;
}

.pfBox p {
  float: left;
}

.pfBox .p2 {
  margin-left: 30px;
}

.pfBox .p3 {
  margin-left: 10px;
}

.ggBox,
.bzBox {
  width: 100%;
  margin-top: 8px;
}

.ggBox div,
.bzBox div {
  width: 10%;
  color: #777;
  height: 30px;
  line-height: 30px;
  float: left;
}

.ggBox ul,
.bzBox ul {
  width: 87%;
  float: left;
}

.ggBox ul li,
.bzBox ul li {
  font-size: 13px;
  color: #777;
  float: left;
  box-sizing: border-box;
  padding: 2px 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  margin-right: 10px;
  cursor: pointer;
}

.ggBox .selecteds {
  border: 1px solid #f64420 !important;
  color: #f64420 !important;
}

.bzBox .selecteds {
  border: 1px solid #f64420 !important;
  color: #f64420 !important;
}

.bzBox ul li:hover,
.ggBox ul li:hover {
  border: 1px solid #f64420 !important;
  color: #f64420 !important;
}

.ggBox::after,
.bzBox::after {
  content: '';
  display: block;
  overflow: hidden;
  clear: both;
  visibility: hidden;
}

.main-top-btn {
  width: 100%;
  height: 40px;
  margin-top: 20px;
}

.main-top-btn .btns {
  float: left;
  width: 120px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  cursor: pointer;
}

.btnL {
  background: #f64420;
  margin-right: 20px;
}

.btnL2 {
  background: #f64420;
  margin-left: 20px;
}

.btnR {
  background: #f68f26;
}

.fen {
  float: right;
  width: 80px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
}

.fen i {
  color: #f64420;
}

.navs {
  width: 100%;
  height: 35px;
  background: #f0f0f0;
  margin-top: 30px;
}

.navs p {
  float: left;
  width: 120px;
  height: 35px;
  line-height: 35px;
  background: #e5e3e3;
  color: #555;
  text-align: center;
  cursor: pointer;
  margin-right: 2px;
}

.navs p:hover {
  background: #f64420;
  color: #fff;
}

.navs p.active {
  background: #f64420;
  color: #fff;
}

.navs .navR {
  float: right;
  background: transparent;
}

.main-table {
  width: 100%;
  height: 198px;
  margin-top: 30px;
}

.main-table table {
  width: 100%;
  height: 198px;
  border: 1px solid #ddd;
  border-collapse: collapse;
}

.main-table table td {
  border: 1px solid #ddd;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.main-table .tableTit {
  width: 12%;
  background: #f6f6f6;
  padding-left: 30px;
}

.main-table .tableTit2 {
  width: 30%;
  text-align: center;
}

.main-table .tableTit2 p {
  width: 400px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.main-table .tableTit3 {
  padding-left: 20px;
}

.explain {
  margin-top: 50px;
}

.explain h3 {
  color: #333;
}

.explain p {
  color: #666;
}

.explainImg {
  width: 100%;
  background: #f6f6f6;
  padding: 40px 0;
  margin: 40px 0;
}

.explainImg img {
  max-width: 100%;
  display: block;
  margin: 0 auto;
}

/* 评价率 */
.Proportion {
  width: 100%;
  height: 110px;
  border: 1px solid #ddd;
  margin-top: 20px;
}

.ProportionL {
  float: left;
  width: 23%;
  height: 70px;
  margin-top: 20px;
  border-right: 1px solid #ddd;
}

.ProportionL1 {
  width: 100%;
  height: 35px;
  text-align: center;
  font-weight: 600;
  font-size: 30px;
  color: #f64420;
}

.ProportionL2 {
  width: 100%;
  text-align: center;
  color: #666;
}

.ProportionC {
  float: left;
  width: 40%;
  height: 90%;
  margin: 0 40px;
}

.ProportionC1 {
  width: 100%;
  height: 20px;
  clear: both;
  margin-top: 10px;
}

.ProportionC span {
  width: 10%;
  display: block;
  float: left;
}

.ProportionC .tiao {
  float: left;
  width: 90%;
}

.ProportionR {
  float: left;
  width: 28%;
  height: 70px;
  margin-top: 20px;
  border-left: 1px solid #ddd;
}

.ProportionR1 {
  height: 30px;
  line-height: 30px;
  text-align: center;
  width: 120px;
  border-radius: 20px;
  background: #f64420;
  color: #fff;
  margin: 0 auto;
  cursor: pointer;
}

.ProportionR2 {
  width: 100%;
  text-align: center;
  color: #666;
  margin-top: 10px;
}

.chenges {
  width: 100%;
  height: 30px;
  background: #f7f7f7;
  margin-top: 20px;
}

.radioList {
  width: 30%;
  height: 30px;
  line-height: 30px;
  float: right;
}

.el-radio {
  margin-right: 20px;
}

.evaluate {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 15px 10px;
  border-bottom: 1px solid #ddd;
}

.evaluate::after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  overflow: hidden;
  visibility: hidden;
}

.evaluate .imgs {
  float: left;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 15px;
}

.evaluate .imgs img {
  width: 100%;
  min-height: 100%;
}

.evaluateC {
  float: left;
  width: 93.5%;
}

.evaluateC1 {
  height: 30px;
  line-height: 30px;
}

.evaluateC1 span {
  display: block;
  float: left;
  color: #333;
  height: 30px;
  line-height: 30px;
}

.evaluateC1 .data {
  margin-left: 10px;
  color: #666;
  font-size: 14px;
}

.evaluateC1 .star {
  float: right;
}

.evaluateC2 {
  width: 100%;
  height: auto;
  word-break: break-all;
}

.evaluateC2 p {
  color: #333;
}

.evaluateC2 ul {
  width: 100%;
  height: 40px;
  margin-top: 10px;
}

.evaluateC2 ul li {
  width: 60px;
  height: 100%;
  float: left;
  margin-right: 10px;
  overflow: hidden;
}

.evaluateC2 ul li img {
  width: 100%;
  min-height: 100%;
}

.evaluateC3 {
  width: 100%;
  height: auto;
  border-top: 1px solid #ddd;
  padding-top: 10px;
  margin-top: 10px;
}

.evaluateC3 p {
  padding: 15px;
  background: #eee;
  color: #999;
}

.sharef {
  margin-top: 20px;
  width: 35%;
  height: 30px;
  float: right;
}

.sharef div {
  float: left;
  margin-right: 10px;
}

.functions {
  width: 100%;
  height: 20px;
  line-height: 20px;
}

.functions p {
  float: right;
  margin-right: 10px;
  cursor: pointer;
}

.evaluateWrap {
  width: 100%;
}

.evaluateWrap2 {
  width: 100%;
  clear: both;
  padding: 10px 0 0 10px;
}

.evaluateWrap2 .evaluateC {
  float: left;
  width: 93%;
}

.evaluateWrap2 .evaluate {
  border: none;
}

.red-border-j {
  border: 1px solid red;
}
</style>

<style>
#ProductDetails .el-input__inner {
  height: 30px !important;
}

#ProductDetails .el-progress-bar__inner {
  background-color: #f64420;
}

#ProductDetails .el-input-number__decrease,
#ProductDetails .el-input-number__increase {
  width: 30px;
  height: 28px;
}

#ProductDetails .el-input-number {
  line-height: 30px;
}

#ProductDetails .swiper-button-prev:after,
#ProductDetails .swiper-button-next:after {
  transform: scale(0.8);
}

#ProductDetails .swiper-button-prev {
  position: relative;
  margin-left: -20px;
  margin-top: -100px;
  border: none;
}

#ProductDetails .swiper-button-prev:focus {
  border: none;
}

#ProductDetails .swiper-button-next:focus {
  border: none;
}

#ProductDetails .swiper-button-next {
  position: relative;
  margin-left: 455px;
  margin-top: -40px;
}

#ProductDetails .swiper-container-horizontal {
  width: 90%;
}

#ProductDetails .swiper-container {
  margin-left: 0;
}

.dialogs .el-dialog__header {
  text-align: left;
  color: #11192d;
  font-size: 14px;
  font-weight: 600;
  line-height: 14px;
  margin-bottom: 12px;
  margin-left: 4px;
}

.dialogs .el-dialog__body {
  padding: 0px 15px 20px;
}

.dialogs .addressLists {
  width: 100%;
}

.dialogs .addressLists .addressLi {
  width: 43%;
  float: left;
  background-color: #f3f6f8;
  border: 1px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 400;
  height: 80px;
  margin-right: 12px;
  margin-bottom: 10px;
  padding: 12px 12px 9px;
  position: relative;
}

.dialogs .addressLists .tip {
  background-color: rgba(0, 0, 0, .2);
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
  line-height: 12px;
  padding: 4px;
  position: absolute;
  right: 4px;
  top: 4px;
}

.addressLists .tip .li-top div {
  float: left;
  line-height: 12px;
  margin-bottom: 8px;
  color: #50607a;
  font-family: PingFangSC-Regular;
  font-weight: 400;
}

.addressLists .tip .li-top .top-l {
  font-weight: 600;
  margin-right: 10px;
}

.dialogs .addressLists .tip .li-btm {
  color: #50607a;
  height: 36px;
  line-height: 18px;
}

.addressLi:nth-of-type(2n) {
  margin-right: 0px;
}

.addressLi:hover {
  background-color: #fff !important;
  border: 1px solid #ff6200 !important;
}

.active2 {
  background-color: #fff !important;
  border: 1px solid #ff6200 !important;
}


.addressLists::after,
.li-top::after {
  content: "";
  display: block;
  overflow: hidden;
  visibility: hidden;
  clear: both;
}

.btn2 {
  background-color: #f64420;
  border: 1px solid #f64420;
}

.btn1:hover {
  border: 1px solid #f64420;
  background-color: #f8f8f8;
  color: #f64420;
}

.btn2:hover {
  background-color: #f64420;
  border: 1px solid #f64420;
}
</style>
<style scoped>
.top-box {
  width: 100%;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #F3F3F5;
  border-radius: 6px;
  box-sizing: border-box;
  padding: 10px;
  margin-bottom: 20px;
}

.top-box-l {
  display: flex;
  align-items: center;

}

.top-box-l1 {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #303030;
  background: rgba(246, 69, 36, 0.11);
  box-sizing: border-box;
  padding: 3px;
}

.top-box-l2 {
  margin-left: 22px;
  font-size: 12px;
  color: #938F8F;
}

.top-box-l2 span {
  color: #096AE0
}

.top-box-r {
  display: flex;
}

.top-box-r .top-box-btn1 {
  cursor: pointer;
  margin-left: 32px;
  display: flex;
  align-items: center;
}

.top-box-btn1 .btn1-img {
  width: 13px;
  height: 13px;
}

.top-box-btn1 .btn1-txt {
  font-size: 14px;
  color: #303030;
  margin-left: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/ShoppingMall/ProductDetails.vue